import { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import Modal from 'react-bootstrap/Modal';
import { wait } from '@testing-library/user-event/dist/utils';
import axios from "axios";
import './Qrcode.css';					  
const Qrcode = ({ showModal,
    setShowModal,
    associado,
    setAssociado,
    executaConsultaAssociado,
    setExecutaConsultaAssociado }) => {

    const [fullscreen, setFullscreen] = useState(true);
    const [scanResult, setScanResult] = useState(null);
    const [nomealuno, setNomealuno] = useState("");
    const [registraPresencaPut, setRegistraPresencaPut] = useState(null)
    const [objPresenca, setObjPresenca] = useState(null)
    const fechaModal = () => {
        setShowModal(false)
    }

    // ajustar também em Associado.jsx
    useEffect(() => {
        async function putPresenca(objPresenca) {

            try {
                console.log("objPresenca", objPresenca)
                const response = await axios.put("https://ricktool.com/api/presenca", objPresenca);
                // const response = await axios.put("http://localhost:4015/api/presenca", objPresenca);
                alert("Presença registrada sucesso!")
            } catch (error) {
                alert("Erro de inclusão. Erro: " + error)
                console.error("Error de inclusao de presença:", error);
            }

        }
        objPresenca && putPresenca(objPresenca);
    }, [objPresenca, registraPresencaPut])

    // ajustar também em Associado.jsx
    // Get no associado para 
    // posteriormete poder efetuar um put de presença
    useEffect((associado) => {
        async function consultaAssociado(scanResult, associado) {

            let url = "";
            url = `https://ricktool.com/api/alunoId?id=${scanResult}`;
            // url = `http://localhost:4015/api/alunoId?id=${scanResult}`;
           
            scanResult && await fetch(url)
                .then((response) => response.json())
                .then((result) => {
                    setNomealuno(result[0].nomealuno);
                })
                .then((result) => {
                    const data = new Date()
                    const ano = data.getFullYear();
                    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Mês começa em 0
                    const dia = String(data.getDate()).padStart(2, '0');

                    if (nomealuno) {
                        setObjPresenca({
                            "nomeAluno": nomealuno,
                            "idAluno": scanResult,
                            "dataPresenca": `${ano}-${mes}-${dia}`
                        })

                    }
                    setRegistraPresencaPut(registraPresencaPut + 1)
                
                })
                .catch((error) => console.log("Erro ao incluir qrcode", error));
              
        }
        console.log('setRegistraPresencaPut' + nomealuno)
        consultaAssociado(scanResult, associado);
    }, [nomealuno, executaConsultaAssociado]);

    async function registraPresenca() {
        // await waitConsultaAssociado()
        setExecutaConsultaAssociado(executaConsultaAssociado + 1) 
        console.log("dentro da chamada", executaConsultaAssociado)
        setNomealuno(null)
    }
    useEffect(() => {
        // Inicializa o scanner no elemento com id "reader"
        let scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width: 250,
                height: 250,
            },
            fps: 5, // Quadros por segundo
        });

        function onScanSuccess(decodedText, decodedResult) {        
            setScanResult(decodedText);
            registraPresenca();
            // scanner.clear();
        }

        function onScanError(err) {
            // Erros de leitura (ignorado para evitar spam no console)
        }

        scanner.render(onScanSuccess, onScanError);
        // Limpeza ao desmontar o componente
        return (()=>{
            console.log("clear")
            scanner.clear().catch(error => {
                console.error("Falha ao limpar o scanner", error);
            });
        })
    }, []);

    return (
        <Modal show={showModal} fullscreen={fullscreen} onHide={() => fechaModal()}>

            <Modal.Header className='modalHeader' data-bs-theme="dark" closeButton onClick={() => fechaModal()}>
                <Modal.Title className='modalTitulo' >Presença por CODE</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='regras'>
                    <div style={{ textAlign: 'center' }}>
                        <h1>Scanner de QR Code</h1>
                        {scanResult ? (
                            <div>
                                <p>Resultado: {JSON.stringify(nomealuno)}</p>
                            </div>
                        ) : (
                            <div id="reader"></div>
                        )}
                    </div>
                </div>

            </Modal.Body>
        </Modal >
    );
};

export default Qrcode;
